module.exports = __webpack_public_path__ + "static/computer-with-blocks-on-blob-92b981b74fe09ae80b4340877589ae20.jpg";